import React from "react";

const Second_ContactUs = () => {
  const units = [
    {
      title: "UNIT 1",
      heading: "Protein Powder",
      address:
        "A-23, Swagat-3 Industrial Park, Near Kothiya Busstop, Ahmedabad-Indore Highway, Kuha, Ahmedabad, Gujarat, India-382433",
    },
    {
      title: "UNIT 2",
      heading: "Effervescent Tablets / Capsules",
      address:
        "Survey no. 1582, Next to plot no. A-22, Swagat-3 Industrial Park, Near Kothiya Busstop, Ahmedabad-Indore Highway, Kuha, Ahmedabad, Gujarat, India-382433",
    },
    {
      title: "UNIT 3",
      heading: "Cosmetics",
      address:
        "A-22, Swagat-3 Industrial Park, Near Kothiya Busstop, Ahmedabad-Indore Highway, Kuha, Ahmedabad, Gujarat, India-382433",
    },
  ];

  return (
    <div className="bg-[#F2F6EF] py-14 px-4">
      
      {/* Container */}
      <div className="max-w-6xl mx-auto">
        
        <div className="text-center mb-12">
          {/* Small Heading */}
          <p className="uppercase tracking-[4px] text-sm font-semibold text-[#A9C32C] mb-3">
            Your Trusted Manufacturing Partner
          </p>
          {/* Main Heading */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-serif text-[#355931] leading-tight">
            Advanced Manufacturing{" "}
            <span className="bg-gradient-to-r from-[#355931] to-[#A9C32C] bg-clip-text text-transparent">
              Units
            </span>
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          
          {units.map((unit, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 hover:shadow-md transition duration-300"
            >
              {/* Badge */}
              <span className="inline-block bg-[#e6ebe5] text-[#2d3b2f] text-xs font-semibold px-4 py-1 rounded-md mb-4">
                {unit.title}
              </span>

              {/* Heading */}
              <h3 className="text-[#2d3b2f] font-semibold text-lg mb-2">
                {unit.heading}
              </h3>

              {/* Address */}
              <p className="text-gray-600 text-sm leading-relaxed">
                {unit.address}
              </p>
            </div>
          ))}

        </div>

      </div>
    </div>
  );
};

export default Second_ContactUs;